<template>
  <section class="pdfModal">
    <div class="pdfWrapper">
      <iframe
        :src="this.googleDriveUrl1 + dataset.url + this.googleDriveUrl2"
        width="100%"
        height="200px"
      />
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'PdfModal',
  props: {
    title: String,
    dataset: Object
  },
  data() {
    return {
      googleDriveUrl:
        'https://drive.google.com/viewerng/viewer?embedded=true&url=',
      googleDriveUrl1: 'https://drive.google.com/viewerng/viewer?url=',
      googleDriveUrl2: '?pid=explorer&efh=false&a=v&chrome=false&embedded=true',
      loading: true
    }
  },
  methods: {
    ...mapMutations('modal', ['hideModal'])
  },
  created() {
    console.log('created')
  },
  mounted() {
    console.log('mounted')
  }
}
</script>

<style lang="scss" scoped></style>
